import { api } from '../../../store/api';
import {
  Answer,
  AnswerRequest,
  AuthorQuiz,
  QuestionReport,
  QuizItem,
  UploadFileResponse,
  UploadFileType,
  AnswerFile,
  ChangeResultBody,
} from './types';
import { RootState } from '../../../store';
interface QuizRes {
  status: boolean;
  listQuestions: QuizItem[];
}

export const quizApi = api.injectEndpoints({
  endpoints: (build) => ({
    getQuiz: build.query<QuizRes, { path: string }>({
      query: ({ path }) => ({
        url: `${path}`,
        method: 'GET',
      }),
      transformResponse: (data: QuizRes) => {
        const excludeTypes: string[] = ['calculated', 'folder'];
        const listQuestions = Object.values(data.listQuestions).filter(
          (i) => !excludeTypes.includes(i.type.sType)
        );
        return {
          listQuestions,
          status: data.status,
        };
      },
    }),
    uploadFile: build.mutation<UploadFileResponse, { file: UploadFileType }>({
      query: ({ file }) => ({
        url: '/polls/fileHandler.php',
        method: 'POST',
        body: file,
      }),
    }),
    saveQuiz: build.mutation<{ status: boolean }, { body: AnswerRequest }>({
      query: ({ body }) => ({
        url: '/polls/saveResult.php',
        method: 'POST',
        body,
      }),
    }),
    getPdf: build.query<any, { path: string }>({
      query: ({ path }) => ({
        url: path,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      transformResponse: (data: any) => {
        if ('reshead' in data) {
          return { resBody: data.resBody, resHead: data.reshead };
        }
        return data;
      },
    }),
    getBlobPdf: build.query<any, { path: string }>({
      query: ({ path }) => ({
        url: path,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
    getQuestionReport: build.query<QuestionReport, { params: string }>({
      query: ({ params }) => ({
        url: `/polls/secretGuestAuthorsStatistics?${params}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getAuthorQuises: build.query<{ title: string; data: AuthorQuiz[] }, { params: string }>({
      query: ({ params }) => ({
        url: `/polls/getSurveys?${params}`,
        method: 'GET',
      }),
    }),
    getQuestion: build.query<
      { info: AuthorQuiz; answers: Answer[]; title: string },
      { params: string }
    >({
      query: ({ params }) => ({
        url: `/polls/surveyResult?${params}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getAnswerFiles: build.query<AnswerFile[], { ID: number }>({
      query: ({ ID }) => ({
        url: `/polls/files?ID=${ID}`,
        method: 'GET',
      }),
      transformResponse: (data: any) => {
        return data.files;
      },
    }),
    getFileByUrl: build.query<any, { path: string }>({
      queryFn: async ({ path }, _queryApi) => {
        try {
          const state = _queryApi.getState() as RootState;
          const id_con = state?.auth?.user?.id_con;

          const response = await fetch(`${path}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              id_con: id_con,
            },
          });

          if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
          }

          const blob = await response.blob();

          // Можно опционально проверить тип
          const contentType = response.headers.get('content-type') || '';
          const cd = response.headers.get('content-disposition');
          let filename = 'file';

          if (cd && cd.includes('filename=')) {
            filename = cd.split('filename=')[1].replace(/["']/g, '').trim();
          }

          const imageUrl = URL.createObjectURL(blob);
          return { data: { url: imageUrl, filename, contentType } }; // Возвращаем всё
        } catch (error: any) {
          return { error: error.message || 'Unknown error' };
        }
      },
    }),
    changeResulrQuiz: build.mutation<{ status: true }, { body: ChangeResultBody }>({
      query: ({ body }) => ({
        url: '/polls/changeResult',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetQuizQuery,
  useSaveQuizMutation,
  useUploadFileMutation,
  useGetPdfQuery,
  useLazyGetBlobPdfQuery,
  useGetQuestionReportQuery,
  useGetAuthorQuisesQuery,
  useGetQuestionQuery,
  useGetAnswerFilesQuery,
  useLazyGetFileByUrlQuery,
  useChangeResulrQuizMutation,
} = quizApi;
